/**
 * TanStack Router: /workforce/employees/$employeeId/edit
 *
 * Employee edit page route
 */
import EditEmployeePage from '@/app/workforce/employees/[id]/edit/page'
import { createFileRoute } from '@tanstack/react-router'

/**
 * Route: /workforce/employees/$employeeId/edit
 * Layout: _auth (authenticated)
 * Component: EditEmployeePage
 */
export const Route = createFileRoute('/_auth/workforce/employees/$employeeId/edit')({
  component: EditEmployeePage,
})
